var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.666504 6.66668L3.33317 4.00001L0.666504 1.33334","stroke":"#0B1E49","strokeLinecap":"round","strokeLinejoin":"round"}));
}

RightArrow.defaultProps = {"width":"4","height":"8","viewBox":"0 0 4 8","fill":"none"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
